import { type RootContainerProps } from "@client/content/types";
import {
  SearchControlled,
  type SearchControlledActionProps,
  type SearchControlledMapProps
} from "@client/controls/Inputs/Search/component";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { search } from "../actions";
import { localStateSelector } from "../selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): SearchControlledMapProps => {
    const localState = localStateSelector(state, props);

    return {
      defaultValue: localState.text,
      iconPosition: "left"
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): SearchControlledActionProps => ({
  onClear: () => dispatch(search({ id: props.id, source: props.source }, "")),
  onEnter: (text: string) => dispatch(search({ id: props.id, source: props.source }, text))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(SearchControlled);
